import { createFileRoute } from "@tanstack/react-router";
import {
  IndustryMarketingPage,
  industryMarketingHead,
  type IndustryFAQ,
} from "@/components/IndustryMarketingPage";

const FAQS: IndustryFAQ[] = [
  {
    "q": "How do trucking companies win direct shipper relationships?",
    "a": "Service-specific pages — dry van, flatbed, reefer, LTL, expedited — that show capability, equipment, and service area. Shippers research carriers; pages that match their freight type win the call."
  },
  {
    "q": "Is SEO worth it for trucking and hauling?",
    "a": "Yes — direct-shipper relationships are worth 3–5x load board freight. Even one direct lane covers a year of SEO investment."
  },
  {
    "q": "How do we recruit more drivers?",
    "a": "Driver-focused pages with pay, home time, equipment, and application forms. Driver recruiting marketing is its own ecosystem — we build a dedicated recruiting funnel parallel to the shipper funnel."
  },
  {
    "q": "Should trucking companies run Google Ads?",
    "a": "Yes — both shipper acquisition and driver recruiting. Ad campaigns for each have very different keyword strategies and we build both."
  },
  {
    "q": "Do you market specialty hauling (oversize, hazmat, heavy)?",
    "a": "Yes — specialty niches have lower competition and higher margins. Specialty pages rank quickly and win premium-rate freight."
  }
];

export const Route = createFileRoute("/trucking-marketing-colorado")({
  head: () =>
    industryMarketingHead("Trucking & Hauling", "trucking or hauling company", "trucking-marketing-colorado", FAQS),
  component: () => (
    <IndustryMarketingPage
      industry={"Trucking & Hauling"}
      industryLower={"trucking or hauling company"}
      slug={"trucking-marketing-colorado"}
      subheadline={"We help Colorado trucking, hauling, and freight companies win shipper relationships and recruit drivers — not chase load boards forever."}
      painPoints={["You compete on load boards instead of building shipper relationships","Driver recruiting is constant and never enough","Your website looks the same as every other carrier"]}
      serviceDescriptions={{
        seo: "Rank for trucking company, freight, hauling, LTL, dry van, flatbed, and every service type across every Colorado market.",
        googleMaps: "Own 'trucking company near me' in the Map Pack so shippers find you direct.",
        webDesign: "Dual-audience sites — shipper-focused service pages plus driver recruiting funnels with applications.",
        ppc: "Profitable Google Ads tuned to direct-shipper relationships and high-quality driver candidates.",
        geoAi: "Get cited when shippers ask ChatGPT 'best trucking company in Colorado' or 'flatbed carrier near me'.",
        socialMedia: "Driver-recruiting content that fills the seat and shipper content that wins the contract.",
      }}
      testimonial={{"quote":"Direct-shipper revenue tripled in eight months and driver applications are steady. We finally have a marketing engine that isn't a load board.","role":"Trucking Company Owner","city":"Denver"}}
      faqs={FAQS}
      cityHubLinks={[{"to":"/colorado-springs","label":"Trucking marketing in Colorado Springs","description":"Carrier and shipper marketing across the Pikes Peak region."},{"to":"/denver-digital-marketing","label":"Trucking marketing in Denver","description":"Direct-shipper and driver recruiting across the Denver freight market."},{"to":"/boulder-digital-marketing","label":"Trucking marketing in Boulder","description":"Specialty and direct freight across Boulder and Northern Colorado."}]}
    />
  ),
});
